import apiInstance from "@services/Shared/instanceAxios";

const getUsers = () =>
  apiInstance({
    url: "/users/",
  });

export default getUsers;
